import React from 'react';
import { Helmet } from 'react-helmet-async';
import Sites from './Sites';
import useRouter from '../../hooks/useRouter';
import PageHeading from '../../@communityshare/ui/PageHeading';
import Results from '../_common_results/Results';
import Site from './Site';
import Filters from '../../forms/filters_sites';
import { BuildingOffice2Icon, FolderIcon } from '@heroicons/react/24/outline';
import MobileNavigation from '../manage/MobileNavigation';
import useDialogLauncher from '../../../hooks/@lore/dialogs-routable/_hooks/useDialogLauncher';
import { DialogManager } from '../../dialogs_new/DialogManager';
import SecondaryAction from '../_components/actions/SecondaryAction';

export default function Layout(props) {
  const router = useRouter();
  const launch = useDialogLauncher();

  function onClick() {
    launch(DialogManager.SiteCreate.Config());
  }

  return (
    <div className="p-8 space-y-8">
      <Helmet>
        <title>Explore Sites</title>
      </Helmet>
      <MobileNavigation />
      <PageHeading
        breadcrumbs={['Manage']}
        title="Sites"
        description={(
          <>
            This page shows all sites. Use the filters to narrow the
            list. Find a filter you want to see again in the future? Bookmark
            the page or save a link to the URL.
          </>
        )}
      >
        <div>
          <SecondaryAction onClick={onClick} secret={true}>
            Create Site
          </SecondaryAction>
        </div>
      </PageHeading>
      <Filters router={router} />
      <Sites router={router}>
        {function(result) {
          return (
            <Results result={result} columns={1} resource="sites" emptyIcon={BuildingOffice2Icon}>
              {function(site, index) {
                return (
                  <Site
                    key={index}
                    site={site}
                  />
                );
              }}
            </Results>
          );
        }}
      </Sites>
    </div>
  );
}
